import { useNavigate } from 'react-router';
import { KeyRound, LogOut } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '../../DropdownMenu';
import { Avatar, AvatarFallback, AvatarImage } from '../../Avatar';
import { useGetUserProfile } from '@/modules/overview/hooks/useGetUserProfile';
import { withErrorAndSuspense } from '@/components/hoc/withErrorAndSuspense';
import IconsComponent from '../../icons/IconsComponent';
import { PROTECTED_ROUTES } from '@/constants/route.constant';

const ProfileDropdown = () => {
  const { data: user } = useGetUserProfile();
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.clear();
    window.location.reload();
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        asChild
        className='z-50 cursor-pointer text-white'
      >
        <Avatar>
          <AvatarImage src={user?.avatar ?? ''} />
          <AvatarFallback className='rounded-full bg-stone-100 p-0 font-semibold text-stone-600 capitalize hover:bg-stone-50'>
            {user?.firstName.toString().charAt(0)}
          </AvatarFallback>
        </Avatar>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className='w-60 border border-white/[0.08] bg-stone-950 p-1.5 text-white shadow-xl shadow-black/40'
        align='end'
        sideOffset={8}
      >
        <DropdownMenuLabel className='px-3 py-2.5'>
          <div className='flex flex-col gap-1.5'>
            <p className='text-sm leading-none font-semibold text-white'>
              {user?.firstName} {user?.lastName}
            </p>
            <p className='text-xs leading-none text-stone-400'>
              {user?.email}
            </p>
          </div>
        </DropdownMenuLabel>

        <DropdownMenuSeparator className='mx-1 bg-white/[0.06]' />

        <DropdownMenuItem
          className='flex cursor-pointer items-center gap-2.5 rounded-md px-3 py-2 text-sm text-stone-300 transition-colors duration-150 hover:bg-white/[0.06] hover:text-white focus:bg-white/[0.06] focus:text-white'
          onClick={() => navigate(PROTECTED_ROUTES.DASHBOARD.SETTINGS)}
        >
          <KeyRound size={15} strokeWidth={1.5} className='text-stone-500' />
          MCP Access Tokens
        </DropdownMenuItem>

        <DropdownMenuSeparator className='mx-1 bg-white/[0.06]' />

        <DropdownMenuItem
          className='flex cursor-pointer items-center gap-2.5 rounded-md px-3 py-2 text-sm text-stone-400 transition-colors duration-150 hover:bg-red-500/10 hover:text-red-400 focus:bg-red-500/10 focus:text-red-400'
          onClick={handleLogout}
        >
          <LogOut size={15} strokeWidth={1.5} />
          Log out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export const ProfileDropdownWithFallback = withErrorAndSuspense(
  ProfileDropdown,
  {
    ErrorFallback: ({ resetErrorBoundary }) => (
      <button
        className='cursor-pointer'
        onClick={resetErrorBoundary}
      >
        <IconsComponent
          icon='regular-user-refresh'
          size='lg'
        />
      </button>
    ),
  },
);
